/**
 * TeacherRoleNote — BON-238: the teacher's own crew position on this workshop,
 * shown atop the detail. Renders nothing outside teacher mode or when
 * unassigned. Extracted from WorkshopDetailPage (one component per file).
 */
import { crewPositionLabel } from '../../../../lib/crewPositions';

import { useWorkshopViewMode } from './workshopDetailContext';

export function TeacherRoleNote({ myRole }: { myRole?: string | null }) {
  if (useWorkshopViewMode() !== 'teacher' || !myRole) return null;
  return (
    <div style={{ fontSize: 12.5, color: 'var(--nb-subtle)' }}>
      You&rsquo;re working this workshop as{' '}
      <strong style={{ color: 'var(--nb-text)' }}>{crewPositionLabel(myRole)}</strong>
    </div>
  );
}
